import React, { useContext, useState } from 'react';
import './NavBar.css';
import { Link, useNavigate } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';
import Select from 'react-select';
import Constants from '../locals/constants.json'


const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, setLanguage, language } = useContext(LanguageContext);
  const Langs = Constants["langs"];
  return (
    <header className="top-nav-bar">
      <div className="nav-logo">
        <div className="logo-icon">
        </div>
        <Link to={`/${language.value}/`} className="logo">
          <img
            src="/images/logo.png"
            alt="Hostel Nut Logo"
            className="logo-image"
          />
        </Link>
      </div>

      <div className="nav-language">
        <div className='logo-lang'>
          <img
            src={`/images/${t("logo")}`}
            alt="flags"
            className="logo-lang-img"
          />
        </div>
        <Select
          value={language}
          onChange={(lang) => setLanguage(lang)}
          options={Langs}
          isSearchable={false}
          styles={{
            control: (base, state) => ({
              ...base,
              backgroundColor: "#ffffff0f", // color del select
              borderColor: state.isFocused ? "var(--border-hover)" : "transparent",
              boxShadow: state.isFocused ? "none" : "none",
              "&:hover": {
                borderColor: state.isFocused ? "var(--border-hover)" : "var(--border-hover)",
                boxShadow: state.isFocused ? "none" : "none",
              }
            }),
            menuList: (base) => ({
              ...base,
              backgroundColor: "#f9fafb",
              padding: 0,
            }),

            /* Cada opción */
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isSelected
                ? "var(--primary)"   // seleccionada
                : state.isFocused
                  ? "#e5e7eb"   // hover
                  : "transparent",

              color: state.isSelected ? "white" : "#111827",
              cursor: "pointer",

              ":active": {
                backgroundColor: "var(--primary)",
              },
            }),

          }}
        />
      </div>


      <nav className="nav-desktop">
        <div className="nav-links">
          <Link to={`/${language.value}/`} className="Home-link notranslate">{t("nav", "home")}</Link>
          <Link to={`/${language.value}/rooms`} className="rooms-link">{t("nav", "rooms")}</Link>
          <Link to={`/${language.value}/location`} className="location-link">{t("nav", "location")}</Link>
          <Link to={`/${language.value}/gallery`} className="gallery-link">{t("nav", "gallery")}</Link>
        </div>
        <Link to={`/${language.value}/booking`} className='btn-book-link' >
          <button className="btn-book">
            <span>{t("nav", "bookNow")}</span>
          </button>
        </Link>
      </nav>

      <button
        className="nav-mobile-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span className="material-symbols-outlined notranslate">menu</span>
      </button>

      {menuOpen && (
        <div className="nav-mobile-menu">
          <Link to={`/${language.value}/`} onClick={() => setMenuOpen(false)}>{t("nav", "home")}</Link>
          <Link to={`/${language.value}/rooms`} className="rooms" onClick={() => setMenuOpen(false)}>{t("nav", "rooms")}</Link>
          <Link to={`/${language.value}/location`} onClick={() => { setMenuOpen(false) }}>{t("nav", "location")}</Link>

          <Link to={`/${language.value}/gallery`} className="gallery" onClick={() => setMenuOpen(false)}>{t("nav", "gallery")}</Link>
          
          <Link to={`/${language.value}/booking`} className='btn-book-link' >
            <button className="btn-book" onClick={() => setMenuOpen(false)} >
              <span>{t("nav", "bookNow")}</span>
            </button>
          </Link>

        </div>
      )}
    </header>
  );
};

export default NavBar;